import React, { FC } from 'react';
import { NavLink } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import s from './NotFound.module.scss';

const NotFound: FC = () => {
    return (
        <>
            <Helmet>
                <meta name="robots" content="noindex, nofollow" />
                <link rel="canonical" href="https://phoenix-programs.com/404" />
                <title>404 - Страница не найдена | Phoenix Programs</title>
                <meta property="og:title" content="404 - Страница не найдена | Phoenix Programs" />
                <meta property="og:description" content="Запрашиваемая страница не существует." />
            </Helmet>
            <div className={s.container}>
                <div className={s.content}>
                    <h1 className={s.title}>404</h1>
                    <h2 className={s.subtitle}>Страница не найдена</h2>
                    <p className={s.description}>
                        К сожалению, запрашиваемая страница не существует или была перемещена.
                    </p>
                    <NavLink to="/" className={s.button}>
                        Вернуться на главную
                    </NavLink>
                </div>
            </div>
        </>
    );
};

export default NotFound;

